import { render, staticRenderFns, recyclableRender, components } from "./diy.vue?vue&type=template&id=778e38ae&"
var renderjs
import script from "./diy.vue?vue&type=script&lang=js&"
export * from "./diy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/diy.vue"
export default component.exports